class NeobrutalistHoneyShowcasePromo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.initLetterWrapping();
      this.initDescriptionSpreader();
      this.initAjaxBuy();
      this.initVariantSelectors();
      this.initProductThumbnails();
      this.initHarvestVideo();
    });
  }

  initCarousel() {
    const track = this.querySelector('.neobrutalist-hsp__carousel-track');
    const prevBtn = this.querySelector('.neobrutalist-hsp__carousel-control--prev');
    const nextBtn = this.querySelector('.neobrutalist-hsp__carousel-control--next');
    
    if (!track) return;

    // Arrow navigation
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        const slideWidth = track.clientWidth * 0.75;
        track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        const slideWidth = track.clientWidth * 0.75;
        track.scrollBy({ left: slideWidth, behavior: 'smooth' });
      });
    }

    // Optional drag-to-scroll support
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('carousel-track--active');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.classList.remove('carousel-track--active');
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('carousel-track--active');
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll speed factor
      track.scrollLeft = scrollLeft - walk;
    });
  }

  initCustomVideos() {
    const cards = this.querySelectorAll('.neobrutalist-hsp__carousel-card');
    
    cards.forEach(card => {
      const video = card.querySelector('.neobrutalist-hsp__carousel-video');
      const btn = card.querySelector('.neobrutalist-hsp__video-play-pause-btn');
      const playIcon = card.querySelector('.play-icon');
      const pauseIcon = card.querySelector('.pause-icon');

      if (!video || !btn) return;

      const togglePlay = () => {
        if (video.paused) {
          video.play().then(() => {
            if (playIcon) playIcon.style.display = 'none';
            if (pauseIcon) pauseIcon.style.display = 'block';
            card.classList.add('video-playing');
          }).catch(err => {
            console.log('Video playback failed:', err);
          });
        } else {
          video.pause();
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
          card.classList.remove('video-playing');
        }
      };

      card.addEventListener('mouseenter', () => {
        video.muted = false;
        video.play().then(() => {
          card.classList.add('video-playing');
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = 'block';
        }).catch(() => { });
      });

      card.addEventListener('mouseleave', () => {
        video.pause();
        card.classList.remove('video-playing');
        if (playIcon) playIcon.style.display = 'block';
        if (pauseIcon) pauseIcon.style.display = 'none';
      });

      // Click card wrapper to play/pause
      card.addEventListener('click', (e) => {
        if (card.parentElement.classList.contains('carousel-track--active')) return;
        togglePlay();
      });

      // Prevent button click double triggering card click
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePlay();
      });
    });
  }

  initLetterWrapping() {
    const headings = this.querySelectorAll('.neobrutalist-hsp__title');
    headings.forEach((heading) => {
      const text = heading.textContent.trim();
      heading.textContent = '';

      [...text].forEach((char) => {
        const span = document.createElement('span');
        span.className = 'neobrutalist-hsp__letter';

        if (char === ' ') {
          span.innerHTML = '&nbsp;';
        } else {
          span.textContent = char;
        }

        heading.appendChild(span);
      });
    });
  }

  initDescriptionSpreader() {
    const desc = this.querySelector('.neobrutalist-hsp__description');
    if (!desc) return;

    this.lastSpawnTime = 0;
    this.wordsList = ['PURE!', 'RAW!', 'SWEET!', 'YUM!', 'ORGANIC!', 'BZZZ!', '100%!', 'GOLDEN!'];

    desc.addEventListener('mousemove', (e) => {
      const now = Date.now();
      if (now - this.lastSpawnTime < 150) return;
      this.lastSpawnTime = now;

      const rect = desc.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const span = document.createElement('span');
      span.className = 'neobrutalist-hsp__spread-word';
      span.textContent = this.wordsList[Math.floor(Math.random() * this.wordsList.length)];
      
      const colors = ['#FFE31A', '#FF007F', '#00FFCC', '#00E5FF', '#FF9100'];
      span.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      span.style.left = `${x}px`;
      span.style.top = `${y}px`;
      span.style.position = 'absolute';
      span.style.pointerEvents = 'none';

      const angle = Math.random() * Math.PI * 2;
      const distance = 40 + Math.random() * 50;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance - 20;
      const rotate = -15 + Math.random() * 30;

      span.style.setProperty('--tx', `${tx}px`);
      span.style.setProperty('--ty', `${ty}px`);
      span.style.setProperty('--tr', `${rotate}deg`);

      // Ensure desc has relative position
      desc.style.position = 'relative';
      desc.appendChild(span);

      setTimeout(() => {
        span.remove();
      }, 900);
    });
  }

  initAjaxBuy() {
    const form = this.querySelector('.neobrutalist-hsp__buy-form form');
    if (!form) return;

    const minusBtn = this.querySelector('.neobrutalist-hsp__qty-btn--minus');
    const plusBtn = this.querySelector('.neobrutalist-hsp__qty-btn--plus');
    const qtyInput = this.querySelector('.neobrutalist-hsp__qty-input');

    // Quantity selectors
    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value, 10) || 1;
        if (currentVal > 1) qtyInput.value = currentVal - 1;
      });
      
      plusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = currentVal + 1;
      });
    }

    // Submit handler
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      
      let clickedButton = e.submitter;
      if (!clickedButton) {
        if (document.activeElement && document.activeElement.type === 'submit' && form.contains(document.activeElement)) {
          clickedButton = document.activeElement;
        }
      }
      const submitter = clickedButton || form.querySelector('.neobrutalist-hsp__submit-btn');
      const isBuyNow = submitter && submitter.classList.contains('neobrutalist-hsp__buy-now-btn');
      
      if (submitter) {
        submitter.setAttribute('disabled', 'true');
        submitter.classList.add('loading');
      }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) throw new Error('Network error adding to cart');
        return response.json();
      })
      .then(data => {
        if (isBuyNow) {
          const srForm = document.getElementById('SrCheckoutForm-Honey');
          if (srForm) {
            const btn = srForm.querySelector('.sr-headless-checkout');
            if (btn) btn.click();
          } else {
            window.location.href = '/checkout';
          }
          return;
        }
        
        // Spawn success particle animation
        this.spawnSuccessBlast(submitter || form);

        // Update standard Shopify cart bubble indicators
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const cartBadges = document.querySelectorAll('#CartCount, .cart-count-bubble, .header__cart-count');
            cartBadges.forEach(badge => {
              badge.textContent = cart.item_count;
              badge.classList.remove('hidden');
              
              // Wiggle animation
              badge.style.animation = 'none';
              requestAnimationFrame(() => {
                badge.style.animation = 'neobrutalist-wiggle-badge 0.4s ease-out';
              });
            });
          });
      })
      .catch(error => {
        console.error('AJAX Quick Buy Form failed:', error);
      })
      .finally(() => {
        if (submitter) {
          submitter.removeAttribute('disabled');
          submitter.classList.remove('loading');
        }
      });
    });
  }

  spawnSuccessBlast(elem) {
    const rect = elem.getBoundingClientRect();
    const centerX = rect.left + window.scrollX + rect.width / 2;
    const centerY = rect.top + window.scrollY + rect.height / 2;
    const svgStar = `<svg viewBox="0 0 24 24" fill="#F2CB05" stroke="#000" stroke-width="2" style="width:1em;height:1em;"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;
    const svgSparkle = `<svg viewBox="0 0 24 24" fill="#04B2D9" stroke="#000" stroke-width="2" style="width:1em;height:1em;"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>`;
    const svgHeart = `<svg viewBox="0 0 24 24" fill="#FF007F" stroke="#000" stroke-width="2" style="width:1em;height:1em;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
    
    const icons = [svgStar, svgHeart, svgSparkle, svgStar, svgSparkle, svgHeart];

    for (let i = 0; i < 15; i++) {
      const p = document.createElement('div');
      p.className = 'neobrutalist-hsp__success-particle';
      p.innerHTML = icons[Math.floor(Math.random() * icons.length)];
      p.style.position = 'absolute';
      p.style.left = `${centerX}px`;
      p.style.top = `${centerY}px`;
      p.style.zIndex = '99999';
      p.style.pointerEvents = 'none';
      p.style.fontSize = `${16 + Math.random() * 16}px`;
      p.style.transform = 'translate(-50%, -50%)';
      p.style.textShadow = '2px 2px 0px #000';

      const angle = Math.random() * Math.PI * 2;
      const speed = 5 + Math.random() * 8;
      const vx = Math.cos(angle) * speed;
      const vy = Math.sin(angle) * speed - 3; // Initial upward drift

      document.body.appendChild(p);

      let x = centerX;
      let y = centerY;
      let opacity = 1.0;

      const animate = () => {
        x += vx;
        y += vy + 0.25; // Apply simulated gravity
        opacity -= 0.025;

        p.style.left = `${x}px`;
        p.style.top = `${y}px`;
        p.style.opacity = opacity;

        if (opacity > 0) {
          requestAnimationFrame(animate);
        } else {
          p.remove();
        }
      };

      requestAnimationFrame(animate);
    }
  }

  initVariantSelectors() {
    const selector = this.querySelector('.neobrutalist-hsp__variant-select');
    if (!selector) return;

    selector.addEventListener('change', () => {
      const option = selector.options[selector.selectedIndex];
      if (!option) return;

      const price = option.getAttribute('data-price');
      const comparePrice = option.getAttribute('data-compare-price');
      const available = option.getAttribute('data-available') === 'true';

      // Update Variant ID Input
      const variantInput = this.querySelector('.neobrutalist-hsp__variant-id');
      if (variantInput) variantInput.value = option.value;

      // Update Price display
      const priceElem = this.querySelector('.neobrutalist-hsp__price');
      const comparePriceElem = this.querySelector('.neobrutalist-hsp__price-compare');
      const saleBadge = this.querySelector('.neobrutalist-hsp__sale-badge');

      if (priceElem) priceElem.textContent = price;

      if (comparePriceElem) {
        if (comparePrice && comparePrice !== price) {
          comparePriceElem.textContent = comparePrice;
          comparePriceElem.style.display = 'inline-block';
          if (saleBadge) saleBadge.style.display = 'inline-flex';
        } else {
          comparePriceElem.style.display = 'none';
          if (saleBadge) saleBadge.style.display = 'none';
        }
      }

      // Update CTA availability
      const submitBtns = this.querySelectorAll('.neobrutalist-hsp__submit-btn');
      submitBtns.forEach(submitBtn => {
        if (available) {
          submitBtn.removeAttribute('disabled');
          const spanText = submitBtn.querySelector('span');
          if (spanText) {
            if (submitBtn.classList.contains('neobrutalist-hsp__buy-now-btn')) {
              spanText.textContent = 'BUY NOW';
            } else {
              spanText.textContent = submitBtn.getAttribute('data-add-text') || 'ADD TO CART';
            }
          }
        } else {
          submitBtn.setAttribute('disabled', 'true');
          const spanText = submitBtn.querySelector('span');
          if (spanText) spanText.textContent = 'SOLD OUT';
        }
      });
    });
  }

  initProductThumbnails() {
    const mainCard = this.querySelector('.neobrutalist-hsp__image-cover-card');
    const thumbBtns = this.querySelectorAll('.neobrutalist-hsp__thumbnail-btn');
    
    if (!mainCard || thumbBtns.length === 0) return;

    thumbBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active class from all buttons
        thumbBtns.forEach(b => b.classList.remove('neobrutalist-hsp__thumbnail-btn--active'));
        
        // Add active class to clicked button
        btn.classList.add('neobrutalist-hsp__thumbnail-btn--active');
        
        // Update main card background image
        const mediaUrl = btn.getAttribute('data-media-url');
        if (mediaUrl) {
          mainCard.style.backgroundImage = `url('${mediaUrl}')`;
        }
      });
    });
  }

  initHarvestVideo() {
    const videoWrapper = this.querySelector('.hsp-storyboard__video-inner');
    if (!videoWrapper) return;

    const playBtn = videoWrapper.querySelector('.neobrutalist-hsp__harvest-play-btn');
    const nativeVideo = videoWrapper.querySelector('video');
    const iframePlaceholder = videoWrapper.querySelector('.neobrutalist-hsp__harvest-iframe-placeholder');

    if (playBtn) {
      playBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        videoWrapper.classList.add('video-playing');

        if (nativeVideo) {
          nativeVideo.play();
          nativeVideo.controls = true;
        } else if (iframePlaceholder) {
          const embedUrl = iframePlaceholder.getAttribute('data-embed-url');
          if (embedUrl) {
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl + (embedUrl.includes('?') ? '&' : '?') + 'autoplay=1';
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media');
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.className = 'neobrutalist-hsp__harvest-video-iframe';

            iframePlaceholder.textContent = '';
            iframePlaceholder.appendChild(iframe);
          }
        }
      });
    }
  }
}

if (!customElements.get('neobrutalist-honey-showcase-promo')) {
  customElements.define('neobrutalist-honey-showcase-promo', NeobrutalistHoneyShowcasePromo);
}
